import { createFileRoute } from '@tanstack/react-router'
import { Navbar, Footer } from '@/components/garmisch'

export const Route = createFileRoute('/_public/privacy')({
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0B]">
      <Navbar />
      <main className="py-24">
        <div className="mx-auto max-w-[800px] px-6">
          <h1 className="mb-8 font-sans text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
            Privacy Policy
          </h1>
          <p className="mb-12 text-gray-500 dark:text-white/60">
            Last updated: January 2025
          </p>

          <div className="space-y-12">
            {/* Introduction */}
            <section>
              <h2 className="mb-4 text-xl font-semibold text-gray-900 dark:text-white">
                Introduction
              </h2>
              <p className="leading-relaxed text-gray-600 dark:text-white/70">
                Garmisch ("we", "our", or "us") is committed to protecting your
                privacy. This Privacy Policy explains how we collect, use, and
                safeguard information when you use our Flutter design system and
                related services.
              </p>
            </section>

            {/* Firebase Analytics */}
            <section>
              <h2 className="mb-4 text-xl font-semibold text-gray-900 dark:text-white">
                Analytics
              </h2>
              <p className="leading-relaxed text-gray-600 dark:text-white/70">
                We use Firebase Analytics to understand how our documentation,
                preview app, and related services are used. This helps us
                improve the product and prioritize features that matter most to
                developers.
              </p>
            </section>

            {/* Data Collection */}
            <section>
              <h2 className="mb-4 text-xl font-semibold text-gray-900 dark:text-white">
                What Data We Collect
              </h2>
              <p className="mb-4 leading-relaxed text-gray-600 dark:text-white/70">
                When you use our services, we may collect:
              </p>
              <ul className="space-y-2 text-gray-600 dark:text-white/70">
                <li className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#448AFF]" />
                  <span>
                    Device information (device type, operating system, browser)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#448AFF]" />
                  <span>
                    Usage interactions (pages visited, features used, time
                    spent)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#448AFF]" />
                  <span>
                    App events (component previews viewed, documentation
                    sections accessed)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#448AFF]" />
                  <span>General location data (country/region level only)</span>
                </li>
              </ul>
            </section>

            {/* No Selling */}
            <section>
              <h2 className="mb-4 text-xl font-semibold text-gray-900 dark:text-white">
                We Do Not Sell Your Data
              </h2>
              <p className="leading-relaxed text-gray-600 dark:text-white/70">
                We do not sell, rent, or trade your personal information to
                third parties. Analytics data is used solely to improve Garmisch
                and understand usage patterns.
              </p>
            </section>

            {/* Data Retention */}
            <section>
              <h2 className="mb-4 text-xl font-semibold text-gray-900 dark:text-white">
                Data Retention
              </h2>
              <p className="leading-relaxed text-gray-600 dark:text-white/70">
                Analytics data is retained in accordance with Firebase's default
                retention policies. We periodically review and delete data that
                is no longer necessary for improving our services.
              </p>
            </section>

            {/* Contact */}
            <section>
              <h2 className="mb-4 text-xl font-semibold text-gray-900 dark:text-white">
                Contact Us
              </h2>
              <p className="leading-relaxed text-gray-600 dark:text-white/70">
                If you have questions about this Privacy Policy or our data
                practices, please contact us at:
              </p>
              <p className="mt-4 font-mono text-[#448AFF]">
                privacy@garmisch.dev
              </p>
            </section>

            {/* Changes */}
            <section>
              <h2 className="mb-4 text-xl font-semibold text-gray-900 dark:text-white">
                Changes to This Policy
              </h2>
              <p className="leading-relaxed text-gray-600 dark:text-white/70">
                We may update this Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page and updating the "Last updated" date.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
